export enum KeyType {
  Token = 'Token',
}
